import { useDispatch, useSelector } from 'react-redux'
import { MessagePopup } from '@renderforest/rf-components'
import { editorThunks } from 'store/features/editor/thunks'
import { editorSelectors } from 'store/features/editor/selectors'
import { getDataByType } from './utils'
import { ErrorKeys } from 'consts/errorKeys'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { goToProfileSubscriptionsPage } from 'utils'
import { REF_LINKS } from 'consts/refLinks'

const ApiErrorPopup = () => {
  const { type, message = '' } = useSelector(editorSelectors.apiErrorPopupData)
  const dispatch = useDispatch()

  const onClose = () => {
    dispatch(editorThunks.resetApiErrorPopupData())
  }

  const onUpgrade = () => {
    onClose()
    goToProfileSubscriptionsPage(REF_LINKS.LOW_PRIORITY_LIMIT)
  }

  if (!type) {
    return null
  }

  const { description, title, actions } = getDataByType(type as ErrorKeys, {
    onClose,
    onUpgrade
  })
  const _description = description || message

  return (
    <MessagePopup
      isOpen
      type="error"
      title={title || translate(T.SOMETHING_WENT_WRONG_LABEL)}
      message={_description}
      primaryAction={{
        label: translate(actions?.primary.labelKey ?? T.GOT_IT_LABEL),
        onClick: actions?.primary.onClick ?? onClose
      }}
      secondaryAction={
        actions?.secondary
          ? {
              label: translate(actions.secondary.labelKey),
              onClick: actions.secondary.onClick
            }
          : undefined
      }
      onClose={onClose}
    />
  )
}

export default ApiErrorPopup
